import { gql } from "@apollo/client";

import { USER_FRAGMENT } from "@graphql/fragments";

export const SET_USER_IDENTITY = gql`
  ${USER_FRAGMENT}
  mutation setUserIdentity(
    $email: String
    $dateOfBirth: String
    $firstName: String
    $lastName: String
    $preferredName: String
    $phoneNumber: String
    $address: UserAddressInput
    $countryOfCitizenship: String
    $countryOfBirth: String
    $residenceStatus: UserResidenceStatus
    $maritalStatus: UserMaritalStatus
    $spouseFirstName: String
    $spouseLastName: String
    $spouseDateOfBirth: String
  ) {
    setUserIdentity(
      input: {
        email: $email
        dateOfBirth: $dateOfBirth
        firstName: $firstName
        lastName: $lastName
        preferredName: $preferredName
        phoneNumber: $phoneNumber
        address: $address
        countryOfCitizenship: $countryOfCitizenship
        countryOfBirth: $countryOfBirth
        residenceStatus: $residenceStatus
        maritalStatus: $maritalStatus
        spouseFirstName: $spouseFirstName
        spouseLastName: $spouseLastName
        spouseDateOfBirth: $spouseDateOfBirth
      }
    ) {
      ...UserFragment
    }
  }
`;

export const SET_USER_TAX_PROFILE = gql`
  ${USER_FRAGMENT}
  mutation setUserTaxProfile(
    $taxId: String!
    $taxIdType: UserTaxIdType!
    $countryOfTaxResidence: String!
    $stateOfTaxResidence: String!
  ) {
    setUserTaxProfile(
      input: {
        taxId: $taxId
        taxIdType: $taxIdType
        countryOfTaxResidence: $countryOfTaxResidence
        stateOfTaxResidence: $stateOfTaxResidence
      }
    ) {
      ...UserFragment
    }
  }
`;

export const ADD_BENEFICIARY = gql`
  mutation addBeneficiary(
    $firstName: String
    $lastName: String
    $dateOfBirth: DateOfBirth
    $type: BeneficiaryType!
    $taxId: String
    $incomeAt18: IncomeAt18
  ) {
    addBeneficiary(
      input: {
        firstName: $firstName
        lastName: $lastName
        dateOfBirth: $dateOfBirth
        type: $type
        taxId: $taxId
        incomeAt18: $incomeAt18
      }
    ) {
      id
      type
      firstName
      lastName
      dateOfBirth
      goals {
        id
        name
        description
        type
        targetAmountInCents
        currentAmountInCents
        startDate
        endDate
        status
      }
    }
  }
`;

export const UPDATE_BENEFICIARY = gql`
  mutation updateBeneficiary(
    $beneficiaryId: String!
    $firstName: String
    $lastName: String
    $dateOfBirth: DateOfBirth
    $taxId: String
  ) {
    updateBeneficiary(
      input: {
        beneficiaryId: $beneficiaryId
        firstName: $firstName
        lastName: $lastName
        dateOfBirth: $dateOfBirth
        taxId: $taxId
      }
    ) {
      id
      type
      firstName
      lastName
      dateOfBirth
      goals {
        id
        name
        description
        type
        targetAmountInCents
        currentAmountInCents
        startDate
        endDate
        status
      }
    }
  }
`;

export const SET_USER_TRUSTED_CONTACT = gql`
  mutation setUserTrustedContact(
    $trustedContactFirstName: String
    $trustedContactLastName: String
    $trustedContactEmail: String
    $trustedContactPhoneNumber: String
  ) {
    setUserTrustedContact(
      input: {
        trustedContactFirstName: $trustedContactFirstName
        trustedContactLastName: $trustedContactLastName
        trustedContactEmail: $trustedContactEmail
        trustedContactPhoneNumber: $trustedContactPhoneNumber
      }
    ) {
      id
      trustedContactFirstName
      trustedContactLastName
      trustedContactEmail
      trustedContactPhoneNumber
    }
  }
`;
